<template>
  <v-btn color="primary" variant="tonal" :disabled="disabled || !contractId" @click="dialogOpen = true">
    <v-icon start>mdi-email-fast-outline</v-icon>
    {{ $t("ncrm.integrations.companyEmail.send.action") }}
  </v-btn>
  <NcrmCompanyEmailSendDialog
    v-model="dialogOpen"
    entity-type="contract"
    :entity-id="contractId"
    :recipient-email="recipient.email"
    :recipient-name="recipient.name"
    @notify="$emit('notify', $event)"
    @sent="$emit('sent', $event)"
  />
</template>

<script>
import NcrmCompanyEmailSendDialog from "@/components/ncrm/shared/NcrmCompanyEmailSendDialog.vue";
import { resolveContractEmailRecipient } from "@/Utile/ncrmContractEmail.mjs";

export default {
  name: "NcrmContractEmailAction",
  components: {
    NcrmCompanyEmailSendDialog,
  },
  props: {
    contract: {
      type: Object,
      default: () => ({}),
    },
    contractId: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["notify", "sent"],
  data() {
    return {
      dialogOpen: false,
    };
  },
  computed: {
    recipient() {
      return resolveContractEmailRecipient(this.contract || {});
    },
  },
};
</script>
